module.exports = __webpack_public_path__ + "img/Tokyo Kombat.458b9c54.jpg";